export default {
  jwt: null,
  email: null,
  isSSO: false,
};
